import React from "react";

interface ErrorCircleIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const ErrorCircleIcon: React.FC<ErrorCircleIconProps> = ({
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="#FCEDED"
      />
      <path
        d="M11.9997 8.66732C12.3663 8.66732 12.6663 8.96732 12.6663 9.33398V12.0007C12.6663 12.3673 12.3663 12.6673 11.9997 12.6673C11.633 12.6673 11.333 12.3673 11.333 12.0007V9.33398C11.333 8.96732 11.633 8.66732 11.9997 8.66732ZM11.993 5.33398C8.31301 5.33398 5.33301 8.32065 5.33301 12.0007C5.33301 15.6807 8.31301 18.6673 11.993 18.6673C15.6797 18.6673 18.6663 15.6807 18.6663 12.0007C18.6663 8.32065 15.6797 5.33398 11.993 5.33398ZM11.9997 17.334C9.05301 17.334 6.66634 14.9473 6.66634 12.0007C6.66634 9.05398 9.05301 6.66732 11.9997 6.66732C14.9463 6.66732 17.333 9.05398 17.333 12.0007C17.333 14.9473 14.9463 17.334 11.9997 17.334ZM12.6663 15.334H11.333V14.0007H12.6663V15.334Z"
        fill="#961515"
      />
    </svg>
  );
};

export default ErrorCircleIcon;
